class PredictiveSearchManuly extends SearchForm {
    constructor() {
        super();
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        super.onChange();
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            // Remove the results when they are no longer relevant for the new search term
            // so they don't show up when the dropdown opens again
            this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        }

        // Update the term asap, don't wait for the predictive search query to finish loading
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);

        this.searchTerm = newSearchTerm;

        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }

        this.getSearchResults(this.searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
            this.searchTerm = '';
            this.abortController.abort();
            this.abortController = new AbortController();
            this.closeResults(true);
        }
    }

    onFocus() {
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) return;

        if (this.searchTerm !== currentSearchTerm) {
            // Search term was changed from other search input, treat it as a user change
            this.onChange();
        } else if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(this.searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }

    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
            event.preventDefault();
        }
    }

    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
        const currentButtonText = searchForTextElement?.innerText;
        if (currentButtonText) {
            /*     if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
                   // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
                   return;
                 }*/
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText;
        }
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');

        // Filter out hidden elements (duplicated page and article resources) thanks
        // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
        const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
            (element) => element.offsetParent !== null
        );
        let activeElementIndex = 0;

        if (moveUp && !selectedElement) return;

        let selectedElementIndex = -1;
        let i = 0;

        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
            if (allVisibleElements[i] === selectedElement) {
                selectedElementIndex = i;
            }
            i++;
        }

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
            activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        } else if (moveUp) {
            activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        }

        if (activeElementIndex === selectedElementIndex) return;

        const activeElement = allVisibleElements[activeElementIndex];

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

        if (selectedOption) selectedOption.click();
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        var sURL = "/products/manuly-set?variant=48215316758852";
        var mURL = "/products/manuly-set?variant=48215317053764";
        var lURL = "/products/manuly-set?variant=48215317315908";

        var searchesS = ['affenpinscher', 'alopekis', 'australian terrier', 'havapoo', 'bedlington terrier', 'bichon frisé', 'bologneser', 'bolonka-zwetna', 'border terrier', 'boston terrier', 'cairn terrier', 'cavalier king charles spaniel', 'cavapoo', 'cesky terrier', 'chihuahua', 'chinesische schopfhund', 'coton de tuléar', 'dackel', 'dandie dinmont terrier', 'dänisch schwedischer hofhund (dansk svensk gardshund)', 'deutscher jagdterrier', 'drahthaar-foxterrier', 'französische bulldogge', 'glatthaar-foxterrier', 'havaneser', 'italienisches windspiel (italian greyhound)', 'jack russell terrier', 'japan chin', 'japan spitz', 'kleinpudel', 'kokoni', 'kontinentaler zwergspaniel (papillon)', 'lakeland terrier', 'lhasa apso', 'löwchen', 'malteser', 'maltipoo', 'manchester terrier', 'miniature bull terrier', 'mops', 'norfolk terrier', 'norwegischer lundehund', 'norwich terrier', 'parson russell terrier', 'pekingese', 'pomsky', 'prager rattler', 'pudel', 'retro-mops', 'russkiy toy', 'schipperke', 'scottish terrier', 'sealyham terrier', 'shetland sheepdog', 'shih tzu', 'shiranian', 'sussex spaniel', 'tibet spaniel', 'toypudel', 'welsh corgi cardigan', 'welsh corgi pembroke', 'west highland white terrier (westie)', 'yorkshire terrier', 'zwergdackel', 'zwergpinscher', 'zwergpudel', 'zwergschnauzer', 'zwergspitz'];
        var searchesM = ['airedale terrier', 'american bully', 'american cocker spaniel', 'american foxhound', 'american pit bull terrier', 'american staffordshire terrier', 'american water spaniel', 'australian cattle dog', 'australian shepherd', 'australian stumpy tail cattle dog', 'bandog', 'barbet', 'basenji', 'basset hound', 'bayerischer gebirgsschweißhund', 'beagle', 'bearded collie', 'bernedoodle', 'bobtail (old english sheepdog)', 'border collie', 'braque d’auvergne', 'bullterrier', 'ca de bou', 'chow-chow', 'clumber spaniel', 'cockapoo', 'continental bulldog', 'deutsch kurzhaar', 'deutsche bracke', 'deutscher pinscher', 'deutscher wachtelhund', 'elo', 'englische bulldogge', 'english cocker spaniel', 'english foxhound', 'english shepherd', 'english springer spaniel', 'entlebucher sennenhund', 'épagneul breton', 'eurasier', 'field spaniel', 'finnen-spitz', 'finnischer lapphund (suomen lapinkoira)', 'flat-coated retriever', 'golden doodle', 'golden retriever', 'gordon setter', 'großspitz', 'hannoverscher schweißhund', 'hokkaido', 'irish red setter', 'irish soft coated wheaten terrier', 'irish terrier', 'irish water spaniel', 'islandhund', 'kai', 'kanaan hund', 'karelischer bärenhund', 'katalanischer schäferhund', 'kerry blue terrier', 'kishu', 'kleiner münsterländer', 'kleinspitz und mittelspitz', 'kooikerhondje', 'korea jindo dog', 'kroatischer schäferhund', 'kromfohrländer', 'labradoodle', 'lagotto romagnolo', 'laika', 'langhaariger pyrenäenschäferhund', 'lappländischer rentierhund', 'louisiana catahoula leopard dog', 'magyar vizsla', 'miniature american shepherd', 'mudi', 'norwegische buhund', 'norwegischer elchhund (grau)', 'norwegischer elchhund (schwarz)', 'nova scotia duck tolling retriever', 'olde english bulldogge', 'österreichische bracken', 'österreichischer pinscher', 'ostsibirischer laika', 'peruanischer nackthund', 'podenco andaluz', 'podenco canario', 'polnische bracke', 'polnischer niederungshütehund (pon)', 'portugiesischer wasserhund', 'puggle', 'puli', 'pumi', 'russisch-europäischer laika', 'samojede', 'schapendoes', 'schnauzer', 'schwedischer wallhund (västgötaspets)', 'shar pei', 'shiba inu', 'shikoku', 'siberian husky', 'silken windsprite', 'skye terrier', 'spanischer wasserhund', 'stabyhoun', 'staffordshire bullterrier', 'thai ridgeback', 'tibet terrier', 'wäller', 'welsh springer spaniel', 'welsh terrier', 'westfälische dachsbracke', 'westsibirischer laika', 'whippet', 'wolfsspitz', 'yakutskaya laika'];
        var searchesL = ['afghanischer windhund', 'akita inu', 'alaskan husky', 'alaskan malamute', 'altdeutscher schäferhund', 'american akita', 'american bulldog', 'anatolischer hirtenhund', 'appenzeller sennenhund', 'australian kelpie', 'azawakh', 'barsoi', 'beauceron', 'belgischer schäferhund', 'bergamasker hirtenhund', 'berger blanc suisse', 'berger picard', 'berner sennenhund', 'bernhardiner (st. bernhardshund)', 'black and tan coonhound', 'bloodhound', 'boerboel', 'bordeaux dogge', 'bouvier des flandres', 'briard', 'broholmer', 'bullmastiff', 'cane corso', 'chesapeake bay retriever', 'ciobănesc românesc mioritic', 'curly-coated retriever', 'dalmatiner', 'deerhound', 'deutsch drahthaar', 'deutsch langhaar', 'deutsche dogge', 'deutscher boxer', 'deutscher schäferhund', 'dobermann', 'dogo argentino', 'english mastiff (englischer mastiff)', 'english pointer', 'english setter', 'épagneul français', 'epagneul picard', 'fila brasileiro', 'galgo español', 'germanischer bärenhund', 'grand griffon vendéen', 'greyhound', 'groenendael', 'grönlandhund', 'großer münsterländer', 'großer schweizer sennenhund', 'großpudel (königspudel)', 'harzer fuchs', 'holländischer schäferhund', 'hovawart', 'irischer wolfshund', 'jämthund', 'kangal', 'kaukasischer owtscharka', 'komondor', 'kurzhaarcollie', 'kuvasz', 'labrador retriever', 'laekenois', 'landseer', 'langhaarcollie', 'leonberger', 'malinois', 'mastín español (spanischer mastiff)', 'mastino napoletano', 'neufundländer', 'otterhound', 'pharaonenhund', 'presa canario', 'pudelpointer', 'pyrenäen-mastiff', 'pyrenäenberghund (chien de montagne des pyrénées)', 'rafeiro do alentejo', 'rhodesian ridgeback', 'riesenschnauzer', 'rottweiler', 'russischer schwarzer terrier', 'saarloos wolfhond', 'saluki', 'serra da estrela berghund', 'sloughi', 'slovensky cuvac', 'tervueren', 'tibetan mastiff', 'tosa inu', 'tschechoslowakischer wolfshund', 'weimaraner', 'zentralasiatischer owtscharka'];

        const correctRegex = new RegExp(searchTerm);
        var listOfDogs = "";
        var lasrt = 0;
        var res = this.SetRegEx(searchesS, correctRegex, sURL, 0, "s");
        if (res.list !== undefined) {
            listOfDogs = res.list;
            lasrt = res.index
        }
        if (res.list !== undefined) {
            res = this.SetRegEx(searchesM, correctRegex, mURL, lasrt, "m");
            listOfDogs += res.list;
            var lasrt = res.index
        }
        if (res.list !== undefined) {
            res = this.SetRegEx(searchesL, correctRegex, lURL, lasrt, "l");
            listOfDogs += res.list;
        }


        var text = "<div id=\"predictive-search-results\" role=\"listbox\">\n" +
            "    <div id=\"predictive-search-results-groups-wrapper\" class=\"predictive-search__results-groups-wrapper\">\n" +
            "        <div class=\"predictive-search__result-group\">\n" +
            "            <div>\n" +
            "                <h2 id=\"predictive-search-queries\"\n" +
            "                    class=\"predictive-search__heading text-body caption-with-letter-spacing\">Vorschläge</h2>\n" +
            "                <ul id=\"predictive-search-results-queries-list\" class=\"predictive-search__results-list list-unstyled\"\n" +
            "                    role=\"group\" aria-labelledby=\"predictive-search-queries\">\n" +
            "                    <li id=\"predictive-search-option-collection-1\" class=\"predictive-search__list-item\" role=\"option\"\n" +
            "                        aria-selected=\"false\">\n" +
            "                        <a href=\"/products/manuly-set\"\n" +
            "                           class=\"predictive-search__item link link--text\" tabindex=\"-1\">\n" +
            "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\">\n" +
            "                                <p class=\"predictive-search__item-heading h5\">Alle Manuly Sets</p>\n" +
            "                            </div>\n" +
            "                        </a>\n" +
            "                    </li>\n" +
            "                </ul>\n" +
            "            </div>\n" +
            "            <div class=\"predictive-search__pages-wrapper\">\n" +
            "                <h2 id=\"predictive-search-pages-desktop\"\n" +
            "                    class=\"predictive-search__heading text-body caption-with-letter-spacing\">Seiten</h2>\n" +
            "                <ul id=\"predictive-search-results-pages-list-desktop\"\n" +
            "                    class=\"predictive-search__results-list list-unstyled\" role=\"group\"\n" +
            "                    aria-labelledby=\"predictive-search-pages-desktop\">\n" +
            "                    <li id=\"predictive-search-option-page-desktop-1\" class=\"predictive-search__list-item\" role=\"option\"\n" +
            "                        aria-selected=\"false\">\n" +
            "                        <a href=\"/pages/faq?_pos=1&amp;_psq=Manul&amp;_ss=e&amp;_v=1.0\"\n" +
            "                           class=\"predictive-search__item link link--text\" tabindex=\"-1\">\n" +
            "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\">\n" +
            "                                <p class=\"predictive-search__item-heading h5\">Manuly FAQs</p>\n" +
            "                            </div>\n" +
            "                        </a>\n" +
            "                    </li>\n" +
            "                    <li id=\"predictive-search-option-page-desktop-2\" class=\"predictive-search__list-item\" role=\"option\"\n" +
            "                        aria-selected=\"false\">\n" +
            "                        <a href=\"/pages/anleitung-fur-auf-und-abbau?_pos=2&amp;_psq=Manul&amp;_ss=e&amp;_v=1.0\"\n" +
            "                           class=\"predictive-search__item link link--text\" tabindex=\"-1\">\n" +
            "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\">\n" +
            "                                <p class=\"predictive-search__item-heading h5\">Manuly Anleitung für Auf- und Abbau</p>\n" +
            "                            </div>\n" +
            "                        </a>\n" +
            "                    </li>\n" +
            "                </ul>\n" +
            "            </div>\n" +
            "        </div>\n" +
            "        <div class=\"predictive-search__result-group\">\n" +
            "            <div>\n" +
            "                <h2 id=\"predictive-search-products\"\n" +
            "                    class=\"predictive-search__heading text-body caption-with-letter-spacing\">Produkte</h2>\n" +
            "                <ul id=\"predictive-search-results-products-list\" class=\"predictive-search__results-list list-unstyled\"\n" +
            "                    role=\"group\" aria-labelledby=\"predictive-search-products\">\n" +
            listOfDogs +
            "\n" +
            "                </ul>\n" +
            "            </div>\n" +
            "            <div class=\"predictive-search__pages-wrapper\">\n" +
            "                <h2 id=\"predictive-search-pages-mobile\"\n" +
            "                    class=\"predictive-search__heading text-body caption-with-letter-spacing\">Seiten</h2>\n" +
            "                <ul id=\"predictive-search-results-pages-list-mobile\"\n" +
            "                    class=\"predictive-search__results-list list-unstyled\" role=\"group\"\n" +
            "                    aria-labelledby=\"predictive-search-pages-mobile\">\n" +
            "                    <li id=\"predictive-search-option-page-mobile-1\" class=\"predictive-search__list-item\" role=\"option\"\n" +
            "                        aria-selected=\"false\">\n" +
            "                        <a href=\"/pages/faq?_pos=1&amp;_psq=Manul&amp;_ss=e&amp;_v=1.0\"\n" +
            "                           class=\"predictive-search__item link link--text\" tabindex=\"-1\">\n" +
            "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\">\n" +
            "                                <p class=\"predictive-search__item-heading h5\">Manuly FAQs</p>\n" +
            "                            </div>\n" +
            "                        </a>\n" +
            "                    </li>\n" +
            "                    <li id=\"predictive-search-option-page-mobile-2\" class=\"predictive-search__list-item\" role=\"option\"\n" +
            "                        aria-selected=\"false\">\n" +
            "                        <a href=\"/pages/anleitung-fur-auf-und-abbau?_pos=2&amp;_psq=Manul&amp;_ss=e&amp;_v=1.0\"\n" +
            "                           class=\"predictive-search__item link link--text\" tabindex=\"-1\">\n" +
            "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\">\n" +
            "                                <p class=\"predictive-search__item-heading h5\">Manuly Anleitung für Auf- und Abbau</p>\n" +
            "                            </div>\n" +
            "                        </a>\n" +
            "                    </li>\n" +
            "                </ul>\n" +
            "            </div>\n" +
            "        </div>\n" +
            "    </div>\n" +
            "\n" +
            "    <div class=\"predictive-search__loading-state\">\n" +
            "        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"spinner\" viewBox=\"0 0 66 66\">\n" +
            "            <circle stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\" fill=\"none\" class=\"path\"></circle>\n" +
            "        </svg>\n" +
            "\n" +
            "    </div>\n" +
            "    <div id=\"predictive-search-option-search-keywords\" class=\"predictive-search__search-for-button\">\n" +
            "        <button class=\"predictive-search__item predictive-search__item--term link link--text h5 animate-arrow\"\n" +
            "                tabindex=\"-1\" role=\"option\" aria-selected=\"false\">\n" +
            "            <span data-predictive-search-search-for-text=\"\">Nach \"Manul\" suchen</span>\n" +
            "            <span class=\"svg-wrapper\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" class=\"icon icon-arrow\"\n" +
            "                                           viewBox=\"0 0 14 10\"><path fill=\"currentColor\" fill-rule=\"evenodd\"\n" +
            "                                                                     d=\"M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546\"\n" +
            "                                                                     clip-rule=\"evenodd\"></path></svg>\n" +
            "</span>\n" +
            "        </button>\n" +
            "    </div>\n" +
            "</div>\n" +
            "\n" +
            "<span class=\"hidden\" data-predictive-search-live-region-count-value=\"\">\n" +
            "    7 Ergebnisse: 2 Seiten, 4 Produkte\n" +
            "  </span>\"";


        let resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('body').innerHTML;


        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);


    }

    SetRegEx(searchesS, correctRegex, url, lastIndex, size) {
        const matchedS = searchesS.filter((str) => correctRegex.test(str));
        var tmp = "";
        for (var i = 0; i < matchedS.length; i++) {
            let matched = matchedS[i];
            var m = matched.split(" ");
            matched = "";
            for (let j = 0; j < m.length; j++) {
                matched += String(m[j]).charAt(0).toUpperCase() + String(m[j]).slice(1) + " ";

            }
            var listOfDogs = "                    <li id=\"predictive-search-option-product-" + lastIndex + "\" class=\"predictive-search__list-item\" role=\"option\"\n" +
                "                        aria-selected=\"false\">\n" +
                "                        <a id=\"searchTarget\" href=\"" + url + "\"\n" +
                "                           class=\"predictive-search__item predictive-search__item--link-with-thumbnail link link--text\"\n" +
                "                           tabindex=\"-1\"><img class=\"predictive-search__image\"\n" +
                "                                              src=\"//manuly.de/cdn/shop/files/29_SetSTeddy.png?v=1708505238&amp;width=150\"\n" +
                "                                              alt=\"Manuly Set \" width=\"50\" height=\"50.0\">\n" +
                "                            <div class=\"predictive-search__item-content predictive-search__item-content--centered\"><p id=\"searchDesc\"\n" +
                "                                    class=\"predictive-search__item-heading h5\">Manuly Set f&uuml;r einen " + matched + "(Größe: " + size.toUpperCase() + ") </p></div>\n" +
                "                        </a>\n" +
                "                    </li>\n";
            tmp += listOfDogs;
        }

        return {list: tmp, index: lastIndex};
    }

    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);

        this.setLiveRegionResults();
        this.open();
    }

    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
        this.resultsMaxHeight =
            window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
    }

    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
    }

    close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }

    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
    }
}

customElements.define('predictive-search-manuly', PredictiveSearchManuly);
